const devEnv = {
    name : "development",
    API_URL : "https://api.leanstack.co",
    CUSTOMER_URL : "https://frontend.leanstack.co:3001"
}
export default devEnv 